import React from "react";
import MuiRadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./RadioGroup.module.scss";
import cn from "classnames";

type DefaultOptionType = { label: string; value: string };

type Props<T = DefaultOptionType> = RadioGroupProps & {
  options: T[];
  getOptionLabel?: (option: T) => string;
  getOptionValue?: (option: T) => string;
  isRequired?: boolean;
  label?: string;
};

const RadioGroup = <T = DefaultOptionType,>({
  options,
  isRequired,
  label,
  getOptionLabel = (option) => (option as DefaultOptionType)?.label,
  getOptionValue = (option) => (option as DefaultOptionType)?.value,
  value,
  onChange,
  ...props
}: Props<T>) => {
  return (
    <MuiRadioGroup
      {...props}
      value={value ?? ""}
      onChange={onChange}
      onBlur={props.onBlur}
      name={props.name}
      ref={props.ref}
      className={cn(props.className, styles.form__radio)}
    >
      {(label || isRequired) && (
        <div className={styles.form}>
          <p className={styles.form__label}>{label}</p>
          {isRequired && <span className={styles.form__error}>*</span>}
        </div>
      )}
      {options.map((option) => {
        return (
          <FormControlLabel
            key={getOptionLabel(option)}
            value={getOptionValue(option)}
            control={<Radio />}
            label={getOptionLabel(option)}
          />
        );
      })}
    </MuiRadioGroup>
  );
};

export default RadioGroup;
